<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div
			class="font-general-regular text-lg text-ternary-dark dark:text-ternary-light"
		>
			&copy; {{ copyrightDate }} Original Template by
			<a
				href="https://github.com/realstoman/vuejs-tailwindcss-portfolio"
				target="_blank"
				rel="noopener noreferrer"
				class="font-general-medium hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
				>realstoman</a
			>. Modified &amp; Developed by
			<span class="font-general-medium">石晓芳</span>. All rights
			reserved.
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
